import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { Link } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import _ from 'lodash';

const StyledLink = styled(props => <Link {...props} />)`
  font-style: normal;
  font-weight: 400;
  color: white;
  border-radius: 0.8rem;
  padding: 0.25rem;
`;

export default class ProjectCategories extends Component {
  render() {
    const { projectcategories } = this.props;
    return (
      <>
        {_.sortBy(projectcategories, ['name']).map((cat, i) => (
          <React.Fragment key={cat.name}>
            {!!i && ' | '}
            <StyledLink style={{ backgroundColor: cat.category_colour }} to={`/project-categories/${kebabCase(cat.name)}`}>{cat.name}</StyledLink>
          </React.Fragment>
        ))}
      </>
    );
  }
}

ProjectCategories.propTypes = {
    projectcategories: PropTypes.array.isRequired,
};
